export const GetUrl = () => {
        if (process.env.NODE_ENV === "development") {
            return "https://localhost:44365/api/OpenApproval";
        } else {
            return "https://trevor-api.ccup.uk/api/OpenApproval";
        }

    }